import preprocessResponse from 'ha/utils/preprocessResponse';
import FetchClient from 'ha/helpers/FetchClient';

export default function createTranslationService(
  { languageDetectionURL }: { languageDetectionURL: string },
  fetchClient: FetchClient,
) {
  return {
    detectLanguage: (text: string) =>
      fetchClient
        .fetch(languageDetectionURL, {
          method: 'POST',
          mode: 'cors',
          body: text,
        })
        .then(preprocessResponse)
        .then(({ lang }: { lang: string }) => lang),
  };
}
